import { IBaseConfiguration } from './config.types';

export const ProdOptions: IBaseConfiguration = {
  baseUrl: '/api',
  hubUrl: '/notificationHub',
  projectHubUrl: '/projectHub',
  uploadsHubUrl: '/uploadsHub',
  version: 'd0d7336b8945cbc16c3709c4d9dddf9906488ebd',
};
